<!-- 智能门窗 -->
<template>
    <div class='smartDoorsWindows'>
        <div class="banner">
            <img src="" alt="">
        </div>
        <div class="main">
            <div class="swiper">
                <el-carousel :interval="5000" type="card" height="300px">
                    <el-carousel-item>
                        <img src="" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img src="" alt="">
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'smartDoorsWindows',
    components: {},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    methods: {

    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.smartDoorsWindows {
    width: 100%;

    .banner {
        width: 100%;

        img {
            width: 100%;
        }
    }

    .main {
        width: 1200px;
        margin: 0 auto;

        .swiper {
            width: 100%;

            img {
                width: 100%;
                height: 300px;
                background-color: #ccc;
            }
        }
    }
}
</style>